import React, { Component, Fragment } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import IntlMessages from 'util/IntlMessages';
import CustomScrollbars from 'util/CustomScrollbars';
import ModulesContainer from 'containers/ModulesContainer';

class SidenavContent extends Component {
    componentDidMount() {
        const { history } = this.props;
        const that = this;
        const pathname = `#${history.location.pathname}`; // get current path

        const subMenuLi = document.querySelectorAll('.sub-menu > li');
        for (let i = 0; i < subMenuLi.length; i++) {
            subMenuLi[i].onclick = function(event) {
                event.stopPropagation();
            };
        }

        const menuLi = document.getElementsByClassName('menu');
        for (let i = 0; i < menuLi.length; i++) {
            menuLi[i].onclick = function(event) {
                for (let j = 0; j < menuLi.length; j++) {
                    const parentLi = that.closest(this, 'li');
                    if (menuLi[j] !== this && (parentLi === null || !parentLi.classList.contains('open'))) {
                        menuLi[j].classList.remove('open');
                    }
                }
                this.classList.toggle('open');
                event.stopPropagation();
            };
        }

        const activeLi = document.querySelector('a[href="' + pathname + '"]'); // select current a element
        try {
            const activeNav = this.closest(activeLi, 'ul'); // select closest ul
            if (activeNav.classList.contains('sub-menu')) {
                this.closest(activeNav, 'li').classList.add('open');
            } else {
                this.closest(activeLi, 'li').classList.add('open');
            }
        } catch (error) {}
    }

    closest(el, selector) {
        try {
            let matchesFn;
            // find vendor prefix
            ['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'].some(function(fn) {
                if (typeof document.body[fn] == 'function') {
                    matchesFn = fn;
                    return true;
                }
                return false;
            });

            let parent;

            // traverse parents
            while (el) {
                parent = el.parentElement;
                if (parent && parent[matchesFn](selector)) {
                    return parent;
                }
                el = parent;
            }
        } catch (e) {}

        return null;
    }

    render() {
        return (
            <CustomScrollbars className="scrollbar" style={{ height: 'calc(100vh - 70px)' }}>
                <ul className="nav-menu">
                    <li className="nav-header">
                        <IntlMessages id="navigation.main.title" />
                    </li>
                    <li className="menu no-arrow">
                        <NavLink to="/app/dashboard">
                            <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
                            <span className="nav-text">
                                <IntlMessages id="dashboard.title" />{' '}
                            </span>
                        </NavLink>
                    </li>

                    {/*                    {this.props.navigationSettings.analysis && (
                        <ModulesContainer module="analysis" className="form-group">
                            <li className="menu no-arrow">
                                <NavLink to={`/app/${this.props.organisationId === 29 ? 'issue-' : ''}analysis`}>
                                    <i className="zmdi zmdi-chart zmdi-hc-fw" />
                                    <span className="nav-text">
                                        <IntlMessages id="analysis.title" />{' '}
                                    </span>
                                </NavLink>
                            </li>
                        </ModulesContainer>
                    )}*/}

                    {this.props.modules.reports && (
                        <Fragment>
                            <li className="nav-header">
                                <IntlMessages id="navigation.reports.title" />
                            </li>
                            <li className="menu no-arrow">
                                <NavLink to="/app/report-table">
                                    <i className="zmdi zmdi-view-list zmdi-hc-fw" />
                                    <span className="nav-text">
                                        <IntlMessages id="reportTable.title" />{' '}
                                    </span>
                                </NavLink>

                                <NavLink to="/app/report-map">
                                    <i className="zmdi zmdi-google-maps zmdi-hc-fw" />
                                    <span className="nav-text">
                                        <IntlMessages id="reportMap.title" />{' '}
                                    </span>
                                </NavLink>

                                <NavLink to="/app/report-archive">
                                    <i className="zmdi zmdi-archive zmdi-hc-fw" />
                                    <span className="nav-text">
                                        <IntlMessages id="archive.title" />{' '}
                                    </span>
                                </NavLink>
                            </li>
                            {this.props.navigationSettings.analysis && (
                                <ModulesContainer module="analysis" className="form-group">
                                    <li className="menu no-arrow">
                                        <NavLink to="/app/analysis">
                                            <i className="zmdi zmdi-chart zmdi-hc-fw" />
                                            <span className="nav-text">
                                                <IntlMessages id="analysis.title" />{' '}
                                            </span>
                                        </NavLink>
                                    </li>
                                </ModulesContainer>
                            )}
                        </Fragment>
                    )}

                    {this.props.modules.issues && (
                        <Fragment>
                            <li className="nav-header">Anliegen</li>
                            <li className="menu no-arrow">
                                <NavLink to="/app/issue-table">
                                    <i className="zmdi zmdi-view-list zmdi-hc-fw" />
                                    <span className="nav-text">
                                        <IntlMessages id="reportTable.title" />{' '}
                                    </span>
                                </NavLink>

                                <NavLink to="/app/issue-archive">
                                    <i className="zmdi zmdi-archive zmdi-hc-fw" />
                                    <span className="nav-text">
                                        <IntlMessages id="archive.title" />{' '}
                                    </span>
                                </NavLink>
                            </li>
                            {this.props.navigationSettings.analysis && (
                                <ModulesContainer module="analysis" className="form-group">
                                    <li className="menu no-arrow">
                                        <NavLink to="/app/issue-analysis">
                                            <i className="zmdi zmdi-chart zmdi-hc-fw" />
                                            <span className="nav-text">
                                                <IntlMessages id="analysis.title" />{' '}
                                            </span>
                                        </NavLink>
                                    </li>
                                </ModulesContainer>
                            )}
                        </Fragment>
                    )}

                    {this.props.navigationSettings.organisationSettings && (
                        <li className="nav-header">
                            <IntlMessages id="navigation.settings.title" />
                        </li>
                    )}
                    {this.props.navigationSettings.organisationSettings && (
                        <li className="menu no-arrow">
                            <NavLink to={`/app/organisation/${this.props.organisationId}/edit/users`}>
                                <i className="zmdi zmdi-accounts zmdi-hc-fw" />
                                <span className="nav-text">
                                    <IntlMessages id="userSettings.title" />{' '}
                                </span>
                            </NavLink>
                            <NavLink to={`/app/organisation/${this.props.organisationId}/edit/groups`}>
                                <i className="zmdi zmdi-collection-item zmdi-hc-fw" />
                                <span className="nav-text">
                                    <IntlMessages id="groupSettings.title" />{' '}
                                </span>
                            </NavLink>
                            <NavLink to={`/app/organisation/${this.props.organisationId}/edit/general`}>
                                <i className="zmdi zmdi-balance zmdi-hc-fw" />
                                <span className="nav-text">
                                    <IntlMessages id="organisationSettings.title" />{' '}
                                </span>
                            </NavLink>
                            {this.props.organisationId !== 29 && (
                                <NavLink to={`/app/organisation/${this.props.organisationId}/edit/meldooApp`}>
                                    <i className="zmdi zmdi-smartphone zmdi-hc-fw" />
                                    <span className="nav-text">
                                        <IntlMessages id="meldooAppSettings.title" />{' '}
                                    </span>
                                </NavLink>
                            )}
                        </li>
                    )}
                    {this.props.organisationId !== 29 && this.props.organisationId !== 5091 && (
                        <li className="menu no-arrow mt-3">
                            {
                                // <NavLink to="/app/faq">
                                //     <i className="zmdi zmdi-help zmdi-hc-fw" />
                                //     <span className="nav-text">
                                //         <IntlMessages id="faq.title" />{' '}
                                //     </span>
                                // </NavLink>
                            }
                            <a href="https://www.meldooplus.de/Handbuch.pdf" target="_blank">
                                <i className="zmdi zmdi-book zmdi-hc-fw" />
                                <span className="nav-text">Handbuch</span>
                            </a>
                        </li>
                    )}
                    <li className="menu no-arrow">
                        {
                            // <NavLink to="/app/faq">
                            //     <i className="zmdi zmdi-help zmdi-hc-fw" />
                            //     <span className="nav-text">
                            //         <IntlMessages id="faq.title" />{' '}
                            //     </span>
                            // </NavLink>
                        }
                        <a href="https://www.meldooplus.de/pages/impressum.html" target="_blank">
                            <i className="zmdi zmdi-home zmdi-hc-fw" />
                            <span className="nav-text">
                                <IntlMessages id="impressum.title" />{' '}
                            </span>
                        </a>
                    </li>
                    <li className="nav-header" />
                </ul>
            </CustomScrollbars>
        );
    }
}

function mapStateToProps({ accountSettings, profile }) {
    const { organisationId, navigation } = accountSettings.organisationStructure;
    const { role, modules } = profile.myUserProfile;
    return {
        organisationId,
        role,
        navigationSettings: navigation,
        modules
    };
}

export default connect(
    mapStateToProps,
    null
)(withRouter(SidenavContent));



// WEBPACK FOOTER //
// ./containers/SideNav/SidenavContent.js